module.exports = __webpack_public_path__ + "static/img/4-1b.775bac6c.png";